export default "__VITE_PUBLIC_ASSET__9c33125b__"